<template>
  <main>
    <section class="fk-contents">
      <p class="credit-confirm">{{$t('Payment.ConfirmationHeading')}}</p>

      <div class="mod-has-label">
        <span class="label">{{$t('Order.PaymentMethod')}}</span>
        <div class="mod-normal-box confirm">
          <h3 class="title-lv3">{{brandName}} {{number}}</h3>
        </div>
      </div>

      <div class="mod-has-label">
        <span class="label">{{$t('Payment.PayTotal')}}</span>
        <div class="mod-normal-box confirm-price">
          <h3 class="title-price">￥{{totalPrice}}</h3>
        </div>
      </div>

      <p class="mod-form-btn credit-confirm-btn"><a href="#" class="btn-base btn-main" @click.prevent="executePayment">{{$t('Payment.Pay')}}</a></p>
      <p class="mod-form-btn btn-back"><a href="#" class="btn-base btn-negative btn-quit" @click.prevent="execBack()">{{$t('General.Return')}}</a></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  name: 'FKMOConfirmCreditCard',
  mixins: [ CommonMixin, DisplayErrorMixin ],
  data () {
    return {
      brandName: null,
      number: null,
      totalPrice: null
    }
  },
  computed: {
    getServerTime () {
      return this.$store.getters.serverTime
    },
    getOrderDetail () {
      return this.$store.getters.orderDetail
    },
    getPayment () {
      return this.$store.getters.payment
    },
    getDisabledButton () {
      return this.$store.getters.disabledButton
    }
  },
  methods: {
    executePayment: function (event) {
      if (this.getDisabledButton) {
        return false
      }
      // 注文確定時とカートの内容が異なる場合はエラー
      if (JSON.stringify(this.$store.getters.cart) !== this.CryptoJS.AES.decrypt(sessionStorage.getItem('confirmCart'), process.env.VUE_APP_CART_HASHKEY).toString(this.CryptoJS.enc.Utf8)) {
        window.commonAlert(this.$i18n.t('ErrorMsg.ERR_023'))
        return
      }
      this.setDisabledButton(true)

      let that = this

      // POSTパラメータ
      let params = {
        'token': this.$route.params.token,
        'token_key': this.$route.params.token_key,
        'order_id': this.getOrderDetail.orderId,
        'display_item_info': this.$route.params.display_item_info
      }
      if (this.$route.params.save_card !== null) {
        params = Object.assign(params, { 'save_card': this.$route.params.save_card })
      }
      this.callApi('CreditCardExecPayment',
        params
      )
        .then(function (res) {
          if (res.data.result) {
            // 注文番号をStoreに格納
            let order = that.getOrderDetail
            order.ticketNumber = res.data.value.ticket_number
            that.$store.dispatch('setOrderDetail', order)

            // カートの情報をクリアする
            that.clearCart(true)

            that.$router.push({ name: 'OrderProcessing' })
          } else {
            that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          that.errorFromAxios(error)
        })
        .finally(() => {
          that.setDisabledButton(false)
        })
    },
    // 戻るボタン
    execBack: function () {
      this.$router.push({ name: 'InputCreditCard' })
    }
  },
  mounted () {
    this.brandName = this.getInternationalBrand(this.$route.params.brandName)
    this.number = this.$route.params.number
    this.totalPrice = this.displayThousandsSeparator(this.getOrderDetail.totalPrice)
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfirmCreditCard.vue